export const stripQuotes = (value?: string | null): string | null => {
    if (value == null) return null;
    const trimmed = value.trim();
    return trimmed.replace(/^(['"])(.*)\1$/, '$2');
};
